<script>
import DropDownButton from "../../../theme/atoms/DropDownButton.vue";

export default {
    name: "GuideDrop",
    components: {DropDownButton},
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: [...this.items, {
                key: 'milestones',
                label: trans('general.observations.milestones_badges'),
                image: '/img/badge-placeholder.png'
            }]
        }
    },
    methods: {
        openMilestonesPanel() {
            this.$emit('openMilestonesPanel');
        }
    }
}
</script>

<template>
    <drop-down-button drop-class="guide-drop"
                      :options="data" :text="trans('general.observations.info')" cls="btn-secondary" icon="fi-rr-info" id="guide">
        <template #action="item">
            <div v-if="item.key === 'milestones'" class="clickable">
                <div class="dropdown-divider"></div>
                <div class="d-flex gap-3 py-3 align-items-center dropdown-item px-0" @click="openMilestonesPanel">
                    <i class="fi fi-rr-badge" style="font-size: 26px;"></i>
                    <p class="mb-0 text-dark">{{ item.label }}</p>
                </div>
            </div>
            <div class="d-flex gap-3 py-2 align-items-center" v-else>
                <img class="hov-img-zoom" :src="item.description" width="28" :alt="item.label">
                <p class="mb-0 text-dark">{{ item.label }}</p>
            </div>
        </template>

        <template #divider>
            <div></div>
        </template>
    </drop-down-button>
</template>

<style>
.guide-drop {
    min-width: 280px;
    padding: 10px 15px !important;
}
</style>
